import { render, staticRenderFns } from "./AddTaxiCompany.vue?vue&type=template&id=ccd85292&scoped=true&"
import script from "./AddTaxiCompany.vue?vue&type=script&lang=js&"
export * from "./AddTaxiCompany.vue?vue&type=script&lang=js&"
import style0 from "./AddTaxiCompany.vue?vue&type=style&index=0&id=ccd85292&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd85292",
  null
  
)

export default component.exports